import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CoreComponent} from "../core-component/core.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {SignUpService} from "../../../rg/service/sign-up.service";
import {OtpData} from "../otp/data/otp-data";
import {ForgotPasswordRequestDto} from "../../../rg/types/registration.types";
import {CoreApiService} from "../../service/core-api.service";
import {error} from "@angular/compiler-cli/src/transformers/util";
import {AuthService} from "../../service/auth.service";
import {EuOtpCodeLoginType} from "../../interfaces/core.types";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {CustomerOnboardingInternalStatus} from "../../../cross/user/types/user.types";


@Component({
  selector: 'login-otp-field',
  templateUrl: './login-otp-field.component.html',
  styleUrls: ['./login-otp-field.component.css']
})
export class LoginOtpFieldComponent extends CoreComponent {

  @Input() formGroup: FormGroup | undefined;
  @Input() option: EuOtpCodeLoginType | undefined;
  @Input() enteredContact: string | undefined;
  @Output() onStepComplete = new EventEmitter<number>;

  otpErrorMessage: string | undefined;

  requestOtp: boolean = false;
  confirmOtp: boolean = false;

  constructor(protected formBuilder: FormBuilder,
              protected router: Router,
              protected registrationService: RegistrationApiService,
              protected authService: AuthService,
              protected userApiService: UserApiService,
              protected coreApiService: CoreApiService,
              protected signUpService: SignUpService,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  handleConfirmOtp(event?: OtpData) {

    if (this.busy) {
      return
    }

    this.busy = true;
    this.confirmOtp = true;

    if (this.option != null && this.enteredContact && event?.otp) {


      this.authService.otpLoginVerify(this.option, this.enteredContact, event?.otp).subscribe(res => {

        if (res.verified) {
          this.authService.loginPassCode(res.passCode).subscribe(res => {

            // check where to navigate to
            this.userApiService.getBasicData().subscribe(response => {

              this.busy = false;
              this.confirmOtp = false;

              if (response.onboardingOnRegistrationStatus == CustomerOnboardingInternalStatus.missing) {
                this.router.navigate(["/ob/start"]);
              } else if (response.onboardingOnRegistrationStatus == CustomerOnboardingInternalStatus.pending) {
                this.router.navigate(['/ob/start'], {queryParams: {continue: 'true'}});
              } else if (response.onboardingOnRegistrationStatus == CustomerOnboardingInternalStatus.appointment_missing) {
                this.router.navigate(["/ob/start/4"]);
              } else {
                this.router.navigate(["/ds/home"]);
              }

            }, error => {
              this.busy = false;
              this.confirmOtp = false;
            });
          }, error => {
            this.busy = false;
            this.confirmOtp = false;
          });
        } else {
          this.otpErrorMessage = "Falscher OTP Code.";
          this.busy = false;
          this.confirmOtp = false;
        }

      }, error => {
        this.busy = false;
        this.confirmOtp = false;
      });

    }

  }

  handleRequestOtp(event: OtpData) {

    if (this.busy) {
      return
    }

    this.busy = true;
    this.requestOtp = true;

    if (this.option != null && this.enteredContact) {

      this.authService.otpLoginInitiate(this.option, this.enteredContact).subscribe({
        next: res => {
          this.busy = false;
          this.requestOtp = false;
        },
        error: err => {
          // optionally handle error
          this.busy = false;
          this.requestOtp = false;
        }
      });
    } else {
      this.busy = false;
      this.requestOtp = false;
    }
  }

  handleStepComplete(event: string) {
    const step = event == 'email' ? 1 : 2;
    this.onStepComplete.emit(step);
  }

}
